import { ApiRequest } from "./base";

const apiRoute = "products";

const DEFAULT_SIZES = [
	{
		size_text: "Standard",
		size: "standard",
		price: 0,
		stem_count: 6,
		enabled: true,
	},
	{
		size_text: "Medium",
		size: "medium",
		price: 3,
		stem_count: 10,
		enabled: true,
	},
	{
		size_text: "Large",
		size: "large",
		price: 7,
		stem_count: 14,
		enabled: true,
	},
];

const normalizeProductSizes = (product) => {
	if (!product) return product;

	// Apply default sizes if product has sizes enabled but no sizes defined
	if (product.has_sizes && (!product.sizes || product.sizes.length === 0)) {
		product.sizes = DEFAULT_SIZES;
	}

	return product;
};

const withoutInlineThumbnails = (value) => {
	if (Array.isArray(value)) return value.map(withoutInlineThumbnails);
	if (!value || typeof value !== "object") return value;

	return Object.entries(value).reduce((result, [key, nestedValue]) => {
		if (key !== "frontPageThumbnail" && key !== "front_page_thumbnail") {
			result[key] = withoutInlineThumbnails(nestedValue);
		}
		return result;
	}, {});
};

export const normalizePersonalisationPayload = (payload) => {
	const personalisation = withoutInlineThumbnails(payload ?? {});
	const size = personalisation.size || personalisation.productSize || personalisation.product_size;

	if (size) personalisation.size = String(size).trim().toUpperCase();

	return personalisation;
};

export const ProductApi = {
	async getInfo(id) {
		const response = await ApiRequest(`${apiRoute}/${id}`, "GET");
		if (response.product) {
			response.product = normalizeProductSizes(response.product);
		}
		return response;
	},
	async getInfoBulk(ids = []) {
		const response = await ApiRequest(`${apiRoute}/batch/${ids.join(",")}`, "GET");
		if (response.products) {
			Object.keys(response.products).forEach((key) => {
				response.products[key] = normalizeProductSizes(response.products[key]);
			});
		}
		return response;
	},
	async getRelated(id) {
		return ApiRequest(`${apiRoute}/suggestions/${id}`, "GET");
	},
	async getDeliveryMethods(id, date) {
		const res = await ApiRequest(`${apiRoute}/${id}/delivery-options`, "POST", {
			date: date,
		});

		return res.delivery_options;
	},
	async preparePersonalisation(id, personalisation) {
		const response = await ApiRequest(`${apiRoute}/${id}/add-personalised-card-new`, "POST", {
			personalisation: normalizePersonalisationPayload(personalisation),
		});

		return response.personalisation;
	},
};
